module.exports = __webpack_public_path__ + "static/media/booking_type_demo_graph.368394d3.jpg";